import { useTranslation } from "react-i18next";

import { Button } from "src/core/components/ui/button";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "src/core/components/ui/dialog";
import { useReexamination } from "src/core/hooks/folder/useReexamination";

type ReexaminationModalProps = {
  open: boolean;
  setOpen: (open: boolean) => void;
};

export default function ReexaminationModal({ open, setOpen }: ReexaminationModalProps) {
  const { t } = useTranslation();

  const { handleReexamination, isLoading } = useReexamination(setOpen);
  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogContent hideCloseButton>
        <DialogHeader>
          <DialogTitle>{t("folder.reexamination.title")}</DialogTitle>
        </DialogHeader>
        <DialogDescription className="whitespace-pre-wrap">
          {t("folder.reexamination.description")}
        </DialogDescription>
        <DialogFooter className="gap-4">
          <Button onClick={handleReexamination} loading={isLoading}>
            {t("folder.reexamination.confirm")}
          </Button>
          <Button variant="link" onClick={() => setOpen(false)} disabled={isLoading}>
            {t("global.form.cancel")}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
